import { ArchiveRestore } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface RestoreCustomerButtonProps {
  onRestore: () => void
  disabled?: boolean
}

/** The row action in the customers directory's Archived view. */
export function RestoreCustomerButton({ onRestore, disabled }: RestoreCustomerButtonProps) {
  return (
    <Button
      variant="outline"
      size="sm"
      className="h-8 gap-1.5"
      disabled={disabled}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => { e.stopPropagation(); onRestore() }}
    >
      <ArchiveRestore className="h-3.5 w-3.5" />
      Restore
    </Button>
  )
}
